import(/* webpackMode: "eager" */ "/app/app/(site)/[lang]/error.tsx");
